import { tap, catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import Category from '../../models/Category';
import * as _ from 'lodash';
import ArrayList from "../../models/ArrayList";
import Product from "../../models/Product";
import LengthAwarePaginator from "../../models/LengthAwarePaginator";
import {PreloaderService} from "../../common/services/preloader/preloader.service";
import AsyncProcess from "../../models/AsyncProcess";

@Injectable()
export class AsyncProcessService extends ServiceProvider {
  protected url = '/api/v1/async';

  constructor() {
    super(AppInjector.get(HttpClient), AppInjector.get(ApiUrl), 'AsyncProcess');
  }
  getAllGhostProducts(): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + `?constraints=${JSON.stringify({
      name: 'ghost_product_create'
    })}&page=1&per_page=100&sort=-created_at`).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
          (result as any).data.map(item => new AsyncProcess(item))),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  getAllImportProducts(details): Observable<any> {
    return this.http.get(this.apiUrl.getApiUrl(this.url) + `?constraints=${JSON.stringify({
      name: 'import_products_csv',
      details: details
    })}&page=1&per_page=10&sort=-created_at`).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
        (result as any).data.map(item => new AsyncProcess(item))),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
}
